import gql from "graphql-tag";

export const CREATE_CONNECTION_INVITATION_MUTATION = gql`
  mutation CreateUserConnectionInvitation($userId: Int!) {
    createUserConnection(data: { userId: $userId })
  }
`;
